import floral1 from './/floralsMain.jpg';
import floral2 from './/Florals1.jpg';
import floral3 from './/Florals2.jpg';
import floral4 from './/Florals3.jpg';
import floral5 from './/Florals4.jpg';
import floral6 from './/florals5.jpeg';
import floral7 from './/florals6.jpeg';
import floral8 from './/florals7.jpeg';
import floral9 from './/florals8.jpeg';
import floral10 from './/florals9.jpeg';
import floral11 from './/florals10.jpeg';
import floral12 from './/florals11.jpeg';
import floral13 from './/florals12.jpeg';
import floral14 from './/florals13.jpeg';
import floral15 from './/florals14.jpeg';
import floral16 from './/florals16.jpg';

export interface CustomImage {
  src: string;
  original: string;
  width: number;
  height: number;
}

export const images: CustomImage[] = [
  {
    src: floral1,
    original: floral1,
    width: 200,
    height: 200,
  },
  {
    src: floral2,
    original: floral2,
    width: 320,
    height: 212,
  },
  {
    src: floral3,
    original: floral3,
    width: 320,
    height: 212,
  },
  {
    src: floral4,
    original: floral4,
    width: 320,
    height: 213,
  },
  {
    src: floral5,
    original: floral5,
    width: 320,
    height: 183,
  },
  {
    src: floral6,
    original: floral6,
    width: 400,
    height: 320,
  },
  {
    src: floral7,
    original: floral7,
    width: 320,
    height: 190,
  },
  {
    src: floral8,
    original: floral8,
    width: 280,
    height: 148,
  },
  {
    src: floral9,
    original: floral9,
    width: 320,
    height: 213,
  },
  {
    src: floral10,
    original: floral10,
    width: 248,
    height: 320,
  },
  {
    src: floral11,
    original: floral11,
    width: 180,
    height: 113,
  },
  {
    src: floral12,
    original: floral12,
    width: 313,
    height: 320,
  },
  {
    src: floral13,
    original: floral13,
    width: 320,
    height: 213,
  },
  {
    src: floral14,
    original: floral14,
    width: 320,
    height: 194,
  },
  {
    src: floral15,
    original: floral15,
    width: 320,
    height: 213,
  },
  {
    src: floral16,
    original: floral16,
    width: 271,
    height: 320,
  },
 
  
];